export const REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME =
	'image_generation_safety_violation' as const;
